export default "__VITE_ASSET__5Cr0GDBI__"